import { Map, Slider } from 'coloreact';
import styled from 'styled-components';

export const ColorPickerWrapper = styled.div`
  position: relative;
  background: ${({ theme }) => theme.controlsBg};
  box-shadow: 0px 5px 20px rgba(1, 83, 130, 0.2);
  border-radius: 5px;
  padding: 20px 45px 20px 20px;
`;

export const ColorPickerBoardContainer = styled.div`
  position: relative;
  width: 175px;
  height: 120px;
`;

export const ColorPickerBoard = styled(Map)`
  width: 100%;
  height: 100%;
  border-radius: 5px;
  overflow: visible !important;

  .Map__Pointer {
    width: 16px !important;
    height: 16px !important;
    background: transparent !important;
    border: 2px solid #ffffff !important;
    box-sizing: border-box;
    box-shadow: 0px 0px 5px rgba(0, 17, 34, 0.3);
  }
`;

export const ColorPickerSlider = styled(Slider)`
  left: 100% !important;
  right: 0 !important;
  transform: translateX(15px);
  width: 100%;

  .Slider__Track {
    border-radius: 5px;
    background: linear-gradient(
      rgb(255, 0, 0) 0%,
      rgb(255, 0, 153) 10%,
      rgb(205, 0, 255) 20%,
      rgb(50, 0, 255) 30%,
      rgb(0, 102, 255) 40%,
      rgb(0, 255, 253) 50%,
      rgb(0, 255, 102) 60%,
      rgb(53, 255, 0) 70%,
      rgb(205, 255, 0) 80%,
      rgb(255, 153, 0) 90%,
      rgb(255, 0, 0) 100%
    ) !important;
  }

  .Slider__Pointer {
    box-sizing: border-box;
    border-radius: 50%;
    background: #ffffff !important;
    box-shadow: 0px 0px 5px rgba(0, 17, 34, 0.3);
  }
`;
